window.SOMRAINE_PRODUCTS=[
  {
    "id": "milk-ceremony",
    "name": "Milk Ceremony",
    "glyph": "crescent",
    "role": "Gentle cleansing milk",
    "size": "190 ml",
    "when": "Cleanse",
    "verb": "Cleanse",
    "step": 0,
    "signature": false,
    "line": "A silky milk cleanser that lifts makeup and everyday impurities, leaving skin feeling soft.",
    "story": "A silky milk cleanser that lifts makeup and everyday impurities, leaving skin feeling soft.",
    "use": "Massage gently onto dry or damp facial skin. Rinse with lukewarm water and pat dry. Use as the first step, morning or evening as suitable for your skin.",
    "supplierUrl": "https://www.selfnamed.com/en/private-label-products/face-care/gentle-cleansing-milk",
    "gallery": [
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/trio38-milk-ceremony.webp"]||"assets/trio38-milk-ceremony.webp"),
        "alt": "Milk Ceremony · 190 ml · Somraine Korean Autumn design concept",
        "cap": "Milk Ceremony · 190 ml"
      },
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/supplier38-milk-ceremony-190.webp"]||"assets/supplier38-milk-ceremony-190.webp"),
        "alt": "Supplier digital mockup of Milk Ceremony gentle cleansing milk, 190 ml, in its tall white pump bottle with the Somraine Korean Autumn label.",
        "cap": "Packaging preview · Milk Ceremony · 190 ml"
      },
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/milk-texture.jpg"]||"assets/milk-texture.jpg"),
        "alt": "Gentle cleansing milk texture photographed by Selfnamed",
        "cap": "The texture"
      }
    ]
  },
  {
    "id": "soft-dawn",
    "name": "Soft Dawn",
    "glyph": "leaf",
    "role": "Moisturising day cream",
    "size": "15 ml",
    "when": "Moisturise",
    "verb": "Moisturise",
    "step": 1,
    "signature": false,
    "line": "A silky, quickly absorbed cream with hyaluronic acid and betaine for hydrated, plump-looking skin.",
    "story": "A silky, quickly absorbed cream with hyaluronic acid and betaine for hydrated, plump-looking skin.",
    "use": "Warm a small amount between fingertips and gently massage over clean face and neck. Use in the morning before sunscreen and makeup.",
    "supplierUrl": "https://www.selfnamed.com/en/private-label-products/face-care/moisturising-day-cream-3",
    "gallery": [
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/trio38-soft-dawn.webp"]||"assets/trio38-soft-dawn.webp"),
        "alt": "Soft Dawn · 15 ml · Somraine Korean Autumn design concept",
        "cap": "Soft Dawn · 15 ml"
      },
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/supplier38-soft-dawn-15.webp"]||"assets/supplier38-soft-dawn-15.webp"),
        "alt": "Supplier digital mockup of Soft Dawn moisturising day cream, 15 ml, with its white pump bottle and matching Somraine carton.",
        "cap": "Packaging preview · Soft Dawn · 15 ml"
      },
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/cream-model-body.jpg"]||"assets/cream-model-body.jpg"),
        "alt": "Moisturising day cream texture photographed by Selfnamed",
        "cap": "The texture"
      }
    ]
  },
  {
    "id": "golden-veil",
    "name": "Golden Veil",
    "glyph": "enso",
    "role": "Nourishing facial oil",
    "size": "30 ml",
    "when": "Golden finish",
    "verb": "Finish",
    "step": 2,
    "signature": true,
    "line": "A nourishing facial oil for soft-feeling skin and a luminous sheen. Our signature, in a 30 ml bottle.",
    "story": "A nourishing facial oil for soft-feeling skin and a luminous sheen. Our signature, in a 30 ml bottle.",
    "use": "Warm a few drops between clean fingertips and gently press onto skin, avoiding the eyes. Use alone or after moisturiser as the final skincare step, morning or evening.",
    "supplierUrl": "https://www.selfnamed.com/en/private-label-products/face-care/nourishing-facial-oil-3",
    "gallery": [
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/trio38-golden-veil.webp"]||"assets/trio38-golden-veil.webp"),
        "alt": "Golden Veil · 30 ml · Somraine Korean Autumn design concept",
        "cap": "Golden Veil · 30 ml"
      },
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/supplier38-golden-veil-30.webp"]||"assets/supplier38-golden-veil-30.webp"),
        "alt": "Supplier digital mockup of Golden Veil nourishing facial oil, 30 ml, in a glass dropper bottle beside its matching Somraine carton.",
        "cap": "Packaging preview · Golden Veil · 30 ml"
      },
      {
        "src": ((window.SOMRAINE_ASSET_URLS||{})["assets/oil-texture.jpg"]||"assets/oil-texture.jpg"),
        "alt": "Nourishing facial oil texture photographed by Selfnamed",
        "cap": "The texture"
      }
    ]
  }
];
window.SOMRAINE_EVIDENCE={"milk-ceremony": {"use": "Massage gently onto dry or damp facial skin. Rinse with lukewarm water and pat dry. Use as the first step, morning or evening as suitable for your skin.", "inci": "Aqua/Water, Helianthus Annuus (Sunflower) Seed Oil*, Sucrose Distearate, Glycerin, Dicaprylyl Carbonate, Isoamyl Laurate, Sucrose Stearate, Butyrospermum Parkii (Shea) Butter*, Sodium Levulinate, Palmitic Acid, Stearic Acid, Xanthan Gum, Parfum/Fragrance, Sodium Anisate, Argania Spinosa (Argan) Kernel Oil*, Persea Gratissima (Avocado) Oil*, Simmondsia Chinensis (Jojoba) Seed Oil*, Lactic Acid, Centaurea Cyanus (Cornflower) Flower Extract*, Paeonia Lactiflora (Peony) Root Extract, Ascorbyl Palmitate, Sodium Phytate, Tocopherol, Citrus Aurantium Bergamia Peel Oil, Linalool**, Limonene**, Linalyl Acetate**, Benzyl Salicylate**, Cananga Odorata Oil/Extract, Citral**, Pinene**, Citrus Aurantium Peel Oil"}, "soft-dawn": {"use": "Warm a small amount between fingertips and gently massage over clean face and neck. Use in the morning before sunscreen and makeup.", "inci": "Aloe Barbadensis (Aloe) Leaf Juice*, Caprylic/Capric Triglyceride, Simmondsia Chinensis (Jojoba) Seed Oil*, Glycerin**, Glyceryl Stearate Citrate, Pentylene Glycol, Cetearyl Alcohol, Betaine, Dicaprylyl Carbonate, Parfum/Fragrance, Palmitic Acid, Stearic Acid, Xanthan Gum, Bisabolol*, Nasturtium Officinale (Watercress) Flower/Leaf Extract*, Rubus Fruticosus (Blackberry) Fruit Extract*, Sorbus Aucuparia (Rowan) Fruit Extract*, Ascorbyl Palmitate, Rubus Idaeus (Raspberry) Seed Oil*, Tocopherol, Aqua/Water, Hydrolyzed Hyaluronic Acid, Sodium Hyaluronate, Sodium Phytate, Potassium Hydroxide, Benzyl Salicylate***, Limonene***, Citrus Aurantium Bergamia Peel Oil, Citrus Aurantium Peel Oil, Citral***, Linalool***, Linalyl Acetate***, Pinene***, Cananga Odorata Oil/Extract"}, "golden-veil": {"use": "Warm a few drops between clean fingertips and gently press onto skin, avoiding the eyes. Use alone or after moisturiser as the final skincare step, morning or evening.", "inci": "Simmondsia Chinensis (Jojoba) Seed Oil*, Decyl Cocoate, Prunus Amygdalus Dulcis (Sweet Almond) Oil*, Hippophae Rhamnoides (Sea Buckthorn) Fruit Extract*, Undecane, Tridecane, Argania Spinosa (Argan) Kernel Oil*, Rubus Chamaemorus (Cloudberry) Fruit Extract*, Tocopherol, Persea Gratissima (Avocado) Oil*, Prunus Armeniaca (Apricot) Kernel Oil*, Hippophae Rhamnoides (Sea Buckthorn) Fruit Oil*, Parfum/Fragrance, Borago Officinalis (Borage) Seed Oil*, Oenothera Biennis (Evening Primrose) Oil*, Prunus Domestica (Plum) Seed Oil, Vaccinium Myrtillus (Blueberry) Fruit Extract*, Solanum Lycopersicum (Tomato) Fruit Extract*, Linalool**, Limonene**, Citrus Aurantium Peel Oil, Citronellol**, Linalyl Acetate**, Geraniol**, Terpineol**, Vanillin, Citrus Limon Peel Oil, Juniperus Virginiana Oil, Pogostemon Cablin Oil, Geranyl Acetate**, Pinene**"}};
window.SOMRAINE_FOOTNOTES={"milk-ceremony": "*Ingredients from organic farming. **From natural essential oils.", "soft-dawn": "*Ingredients from organic farming. **Made using organic ingredients. ***From natural essential oils.", "golden-veil": "*Ingredients from organic farming. **From natural essential oils."};
